import React from 'react';
import './headersection.css';

const Headersection = () => {
  return (
    <div className="fluid-container">
      <div className="hero-container">
        <div className="content-wrapper">
          <h1 className="headline">Leadership Hiring</h1>
          <h1 className="headline-simplified"> SIMPLIFIED</h1>
          <h6 className="subheadline">
            <span>India's 1<sup>st</sup>&nbsp;</span> Exclusive Platform for Discovering Leaders
          </h6>
        </div>
      </div>
    </div>
  );
};


export default Headersection;